/* unplugin-vue-components disabled */import { render } from "./VipAgreements.vue?vue&type=template&id=dd1962fe&scoped=true"
import script from "./VipAgreements.vue?vue&type=script&lang=js"
export * from "./VipAgreements.vue?vue&type=script&lang=js"

import "./VipAgreements.vue?vue&type=style&index=0&id=dd1962fe&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1962fe"]])

export default __exports__